// MF-67 — Read-only preview for a journal record (zone / category / template / entry): an optional
// badge header, a two-column facts grid and titled sections. Uses the app's DialogConfirm with no
// action buttons (close via the header ✕). Fact/Facts/PreviewSection are shared with EntryPreview.
import DialogConfirm from '../../../dialog/DialogConfirm'
import { Typography } from '@mui/material'

const isEmpty = (v) => v === null || v === undefined || v === ''

export const Fact = ({ label, value, full = false }) => (
  <div className='flex flex-col' style={{ gap: 4, gridColumn: full ? '1 / -1' : undefined, minWidth: 0 }}>
    <Typography
      style={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: 'rgb(100, 116, 139)'
      }}
    >
      {label}
    </Typography>
    <div
      style={{
        fontSize: 13,
        color: 'rgb(15, 23, 42)',
        wordBreak: 'break-word',
        whiteSpace: 'pre-line'
      }}
    >
      {isEmpty(value) ? <span style={{ color: 'rgb(148, 163, 184)' }}>—</span> : value}
    </div>
  </div>
)

export const Facts = ({ children }) => (
  <div className='grid' style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '16px 24px' }}>
    {children}
  </div>
)

export const PreviewSection = ({ title, children }) => (
  <div
    className='flex flex-col'
    style={{ gap: 12, borderTop: '1px solid rgb(226, 232, 240)', paddingTop: 16 }}
  >
    <Typography style={{ fontSize: 14, fontWeight: 600, color: 'rgb(15, 23, 42)' }}>{title}</Typography>
    {children}
  </div>
)

// rows: [{ label, value, full }]; header: badges row; children: extra sections.
const PreviewDialog = ({ open, title, header, rows = [], onClose, children, maxWidth = 'sm' }) => (
  <DialogConfirm
    id={`journal-preview-${title}`}
    open={open}
    onCancel={onClose}
    showActions={false}
    onCloseHeader
    title={title}
    maxWidth={maxWidth}
  >
    <div className='flex flex-col' style={{ gap: 16, paddingTop: 8 }}>
      {header ? (
        <div className='flex items-center flex-wrap' style={{ gap: 8 }}>
          {header}
        </div>
      ) : null}
      {rows.length ? (
        <Facts>
          {rows.map((r) => (
            <Fact key={r.label} label={r.label} value={r.value} full={r.full} />
          ))}
        </Facts>
      ) : null}
      {children}
    </div>
  </DialogConfirm>
)

export default PreviewDialog
